// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPage-cls1_aBu","cls2":"EvaluationPage-cls2_3lz EvaluationPage-cls1_aBu"};